module.exports = __webpack_public_path__ + "img/9788952114037.93bd73bc.jpg";